// extracted by mini-css-extract-plugin
module.exports = {"padding":"VIP_Alignment__padding"};